export default class InputFieldElementIdGenerator {
  public static getValidationMessageId(id?: string): string | undefined {
    if (!id) {
      return undefined;
    }
    return `${id}ValidationMessage`;
  }
}